const CHUNK_RELOAD_KEY = 'ds-chunk-reload';
const CHUNK_RELOAD_PARAM = '_ds';
const CHUNK_RELOAD_WINDOW_MS = 15000;

const readLastReloadAt = () => {
  try {
    return Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  } catch {
    return 0;
  }
};

export const isChunkLoadError = (error) => {
  const message = String(error?.message || error || '');
  const name = String(error?.name || '');

  return (
    name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Unable to preload CSS') ||
    message.includes("Unexpected token '<'") ||
    (message.includes('MIME type') && message.includes('text/html'))
  );
};

const reloadForFreshBuild = ({ force = false } = {}) => {
  const now = Date.now();
  const lastReloadAt = readLastReloadAt();

  if (!force && lastReloadAt && now - lastReloadAt < CHUNK_RELOAD_WINDOW_MS) {
    return false;
  }

  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  } catch {
    // sessionStorage can throw in private mode; still try a one-time reload.
  }

  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_RELOAD_PARAM, String(now));
  window.location.replace(url.toString());
  return true;
};

export const reloadOnceOnChunkError = (error, options = {}) => {
  if (!isChunkLoadError(error) || typeof window === 'undefined') {
    return false;
  }

  return reloadForFreshBuild(options);
};

export const clearChunkReloadGuard = () => {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }

  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  if (!url.searchParams.has(CHUNK_RELOAD_PARAM)) {
    return;
  }

  url.searchParams.delete(CHUNK_RELOAD_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};
